import { IconButton } from "@mui/material";
import Columns from "../../../library/components/layout/Columns";
import { appIcons } from "../../../app/appIcons";
import { PDF_CANVAS_MAX_WIDTH } from "./pdfCanvasConstants";

interface IPdfCanvasZoomControlsProps {
    pdfWidth: number,
    onPdfWidthChange: (width: number) => void,
}

const PdfCanvasZoomControls = (props: IPdfCanvasZoomControlsProps) => {
    return <Columns gap={4}>
        <IconButton onClick={() => props.onPdfWidthChange(props.pdfWidth * 0.9)}>
            {appIcons.Genel.zoomOut}
        </IconButton>
        <IconButton onClick={() => props.onPdfWidthChange(props.pdfWidth / 0.9)}>
            {appIcons.Genel.zoomIn}
        </IconButton>
        <IconButton onClick={() => props.onPdfWidthChange(PDF_CANVAS_MAX_WIDTH)}>
            {appIcons.Genel.zoomDefault}
        </IconButton>
    </Columns>;
};

export default PdfCanvasZoomControls;
